// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ZnSo","title":"InfoRow_title__3_l4H"};